import * as React from "react";

// Libraries
import MapboxAutocomplete from "react-mapbox-autocomplete";
import moment from "moment-timezone";

// Style Components
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

// Export the Toolbar
export default function GoPlayToolBar(props) {

  // Location suggestion select
  const suggestionSelect = (result, lat, lng, text) => {
    props.mapRef.current.setCenter([
      lng,
      lat,
    ])
    props.mapRef.current.setZoom(11);
    mapboxElement.current.state.resetSearch = false;
  };

  // Mapbox Autocomplete Element Ref
  const mapboxElement = React.useRef()

  // Timer values
  const [days, setDays] = React.useState(0);
  const [hours, setHours] = React.useState(0);
  const [mins, setMins] = React.useState(0);

  // Calculate timer values
  const getCountDown = (time) => {
    const func = setInterval(() => {
      const now = new Date().getTime();
      const timeleft = time - now;
      if (timeleft > 0) {
        setDays(Math.floor(timeleft / (1000 * 60 * 60 * 24)));
        setHours(
          Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        );
        setMins(Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60)));
      } else {
        clearInterval(func);
        setDays(0);
        setHours(0);
        setMins(0);
      }
    }, 1000);
  };

  // Calculate timer values on page load
  React.useEffect(() => {
    const pstDate = new Date(moment.tz("2023-03-21 15:00", "America/Los_Angeles").format())
    getCountDown(new Date(pstDate).getTime());
  }, []);


  return (
    <>
      {/*Tool Bar*/}
      <div>
      <header className="header">

        {/* 3-21 #goplay */}
        <div className="vertical-center ">
          <p className="text-center white flexbox-text text-center threetwoone">3-21</p>
          <p className="text-center white flexbox-text text-center hashgoplay">#goplay</p>
        </div>

        {/* Search Location 'Find An Event'. */}
        <div className="find-event">
          <InputGroup className='input-group-2'>
            <MapboxAutocomplete
                publicKey={process.env.REACT_APP_MAPBOX_TOKEN}
                inputClass="rbt-input-main form-control rbt-input mb-0"
                resetSearch={false}
                placeholder="FIND AN EVENT..."
                onSuggestionSelect={suggestionSelect}
                ref={mapboxElement}
              />
            <InputGroup.Text
              id="inputGroup-sizing-default"
              className="btn-find"
            ></InputGroup.Text>
          </InputGroup>
        </div>

        {/* Timer */}
        <div className="day-hour-min">
          <div className="time">
            <div className="time-input-container">
              <Form.Control
                aria-label="find"
                className="time-input"
                aria-describedby="inputGroup-sizing-default"
                value={days}
                style={{color:"#70d44b"}}
                plaintext readOnly
              />
            </div>
            <InputGroup.Text
              id="inputGroup-sizing-default"
              className="time-input-label days"
            >
              DAYS
            </InputGroup.Text>
          </div>
          <div className="time">
            <div className="time-input-container">
              <Form.Control
                aria-label="find"
                className="time-input"
                value={hours}
                aria-describedby="inputGroup-sizing-default"
                style={{color:"#02abe2"}}
                plaintext readOnly
              />
            </div>
            <InputGroup.Text
              id="inputGroup-sizing-default"
              className="time-input-label hours"
            >
              HOURS
            </InputGroup.Text>
          </div>
          <div className="time">
            <div className="time-input-container">
              <Form.Control
                aria-label="find"
                className="time-input"
                value={mins}
                aria-describedby="inputGroup-sizing-default"
                style={{color:"#602b7b"}}
                plaintext readOnly
              />
            </div>
            <InputGroup.Text
              id="inputGroup-sizing-default"
              className="time-input-label mins"
            >
              MINS
            </InputGroup.Text>
          </div>
        </div>

        {/* Event Count */}
        <div className="events-world-peace">
          <div className="events-world-peace-inner-1">
            <div className="time-2 no-of-events-time">
              <Form.Control
                aria-label="find"
                className="events-input no-of-events text-center"
                value={props.eventsCount ? props.eventsCount : 0}
                aria-describedby="inputGroup-sizing-default"
                plaintext readOnly
              />
            </div>
            <InputGroup.Text
              className="input-label input-label-events"
              id="inputGroup-sizing-default"
            >
              EVENTS
            </InputGroup.Text>
          </div>
        </div>

      </header>
      </div>
    </>
  );
}
